import AsyncStorage from '@react-native-async-storage/async-storage';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Platform, StyleSheet, TouchableOpacity, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { WebView } from 'react-native-webview';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FilledButton from '../../components/FilledButton';
import MyScrollView from '../../components/MyScrollView';
import PtfKeyboardAvoidingView from '../../components/PtfKeyboardAvoidingView';
import Svg from '../../components/Svg';
import Header from '../../components/register/Header';
import Colors from '../../constants/Colors';
import Languages from '../../constants/Languages';
import Layout from '../../constants/Layout';
import * as Actions from '../../store/Actions';
import timeUtils from '../../utils/timeUtils';

import { AppText } from '../../components/AppText';

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.mediumBlue,
  },
  mainContentContainer: {
    alignItems: 'center',
    backgroundColor: Colors.white,
  },
  signupContainer: {
    ...Layout.signupContainer,
    width: '100%',
  },
  topContainer: {
    flex: 1,
    backgroundColor: Colors.white,
    width: '100%',
    alignItems: 'center',
  },
  termContainer: {
    flex: 1,
    paddingHorizontal: 16,
    width: '100%',
  },
  text: {
    fontFamily: 'roboto-regular',
    fontSize: 16,
    color: Colors.veryDarkGray,
    marginLeft: 12,
  },
  acceptContainer: {
    flexDirection: 'row',
    marginBottom: 12,
    marginHorizontal: 32,
  },
  signupFooter: {
    ...Layout.signupFooter,
    width: '100%',
    borderTopWidth: 1,
    borderTopColor: Colors.grayBorder,
    backgroundColor: Colors.lightBackground,
    paddingTop: Layout.isSmall ? 8 : 32,
  },
  buttonContainer: {
    width: 328,
  },
});

class TermsPrivacyScreen extends Component {
  static propTypes = {
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  // @ts-ignore
  constructor(props) {
    super();
    this.state = {
      accepted: false,
    };
  }

  componentDidMount = () => {
    const { registration, actions, navigation } = this.props;
    const { user } = registration;

    if (!user.docs || !user.docs.length) {
      if (user.onboarding_complete) {
        AsyncStorage.setItem('onboarded', '1').then(() => {
          actions.refreshRedux();
          navigation.navigate('a');
        });
      } else {
        navigation.navigate('UserDetails');
      }
    }
  };

  goBack = () => {
    const { navigation } = this.props;
    navigation.navigate('Language');
  };

  goNext = () => {
    const { actions, navigation } = this.props;
    actions.acceptTerms((user) => {
      if (user.onboarding_complete) {
        AsyncStorage.setItem('onboarded', '1').then(() => {
          actions.refreshRedux();
          navigation.navigate('a', { screen: 'pantries' });
        });
      } else {
        navigation.navigate('UserDetails');
      }
    });
  };

  onPress = (checked) => {
    const { accepted } = this.state;
    this.setState({ accepted: !accepted });
  };

  createMarkup = (html) => {
    return { __html: html };
  };

  render() {
    const { registration } = this.props;
    const { user, language } = registration;
    const { accepted } = this.state;
    const translation = Languages.translations[language?.name || 'en'];
    let title = '';
    let htmlBody = '';
    let html = `<!DOCTYPE html>
    <html>
    <head>
      <style type="text/css">
        body {
          font-family: arial;
        }
      </style><meta name="viewport" content="width=device-width, initial-scale=1" />
    </head><body>`;
    if (user && user.docs) {
      user.docs.forEach((term, index) => {
        if (!index) {
          title += term.label;
        } else {
          title += ` ${translation.and} ${term.label}`;
        }
        htmlBody += `<h2>${term.label}</h2>`;
        htmlBody += `<p>${timeUtils.formatDate(term.eula_date)}`;
        htmlBody += `<br/><br/>${term.eula}<br/><br/>`;
      });
    }
    html += htmlBody;
    html += '</body></html>';

    return (
      <SafeAreaView style={{ flex: 1 }} edges={['top', 'left', 'right', 'bottom']}>
        <PtfKeyboardAvoidingView style={{ flex: 1 }}>
          <MyScrollView
            contentContainerStyle={styles.mainContentContainer}
            containerStyle={styles.container}
            testID="terms-privacy"
          >
            <Header title={title} goBack={this.goBack} />
            <View style={styles.signupContainer}>
              <View style={styles.topContainer}>
                <View style={styles.termContainer}>
                  {Platform.OS === 'web' ? (
                    <div
                      style={{ overflowY: 'scroll' }}
                      dangerouslySetInnerHTML={this.createMarkup(htmlBody)}
                    />
                  ) : (
                    <WebView
                      originWhitelist={['*']}
                      source={{ html }}
                      scalesPageToFit={Platform.select({ android: false })}
                    />
                  )}
                </View>
              </View>
              <View style={styles.signupFooter}>
                <TouchableOpacity onPress={this.onPress} style={styles.acceptContainer} testID="accept">
                  <Svg icon={accepted ? 'square_checked' : 'square_unchecked'} />
                  <AppText style={styles.text}>{translation.accept_eula}</AppText>
                </TouchableOpacity>
                <View style={styles.buttonContainer}>
                  <FilledButton
                    onPress={this.goNext}
                    label={translation.submit}
                    color={Colors.primaryColor}
                    full
                    textColor={Colors.white}
                    disabled={!accepted}
                    testID="button-submit"
                  />
                </View>
              </View>
            </View>
          </MyScrollView>
        </PtfKeyboardAvoidingView>
      </SafeAreaView>
    );
  }
}

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TermsPrivacyScreen);
